import React from "react";
import { baseUrl } from "../../lib/routes/baseUrl";
import "./Logo.less";

const Logo = (props: { size?: number }) => {
  const width = props?.size ? `${props.size}px` : undefined;
  return (
    <img
      src={`${baseUrl}/gui-logo/logo.png`}
      alt="logo"
      className="outer-logo"
      style={{
        width,
        height: width,
      }}
    />
  );
};

export default Logo;
